import {
  ITranscription,
  ITranscriptionResponse,
  ITranscriptionSegment,
} from 'Modules/videoHistory/types/transcriptions.types';
import moment from 'moment';

/**
 * Converts a transcription response to a transcription model.
 * @param response - The transcription response to convert.
 * @returns The transcription model.
 */
export const transcriptionResponseToModel = (
  response: ITranscriptionResponse
): ITranscription => {
  return {
    id: response.id,
    status: response.transcript.status,
    segmentCount: response.transcript.segmentCount,
    nextCursor: response.transcript.nextCursor ?? 0,
    startedAt: moment(response.transcript.startedAt),
    segments:
      response.transcript.status === 'AVAILABLE'
        ? (response.transcript.segments ?? []).map(transcriptionSegmentToModel)
        : [],
  } as ITranscription;
};

/**
 * Converts a transcription segment response to a transcription segment model.
 * @param segment - The transcription segment response to convert.
 * @returns The transcription segment model.
 */
const transcriptionSegmentToModel = (
  segment: ITranscriptionResponse['transcript']['segments'][number]
): ITranscriptionSegment => {
  return {
    id: segment.id,
    timestamp: moment(segment.timestamp),
    participantId: segment.participantId,
    personId: segment.personId.toString(),
    displayName: segment.displayName,
    text: segment.text,
  };
};
